var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { FilterContext } from "../../providers/FilterProvider";
import { ColumnDescribedTable, ValidSortDirections } from "../Table/Table";
import styles from "./CohortInsightsSkillsTable.module.scss";
import { DownloadableSection } from "../DownloadableSection/DownloadableSection";
var CohortInsightsSkillsTable = function (_a) {
    var data = _a.data, filename = _a.filename, title = _a.title, getColumnDescriptions = _a.getColumnDescriptions, column1Attribute = _a.column1Attribute, column2Attribute = _a.column2Attribute;
    var getFilters = useContext(FilterContext).getFilters;
    var filters = getFilters();
    var scoreType = filters === null || filters === void 0 ? void 0 : filters.scoreType;
    var filterFunctor = function (record, scoreType) {
        // Ensure low_scores is always an array to avoid errors
        var lowScores = Array.isArray(record === null || record === void 0 ? void 0 : record.low_scores)
            ? record.low_scores
            : [];
        return scoreType == null || lowScores.indexOf(scoreType) > -1;
    };
    var tableData = Array.isArray(data)
        ? data.filter(function (record) { return filterFunctor(record, scoreType); })
        : [];
    return (_jsxs(DownloadableSection, __assign({ filename: filename }, { children: [_jsxs("div", { children: [_jsx("div", __assign({ className: styles.cohortTableHeaderContainer }, { children: _jsxs("div", __assign({ className: styles.cohortTableHeader }, { children: [title, " "] })) })), _jsx("div", { className: styles.cohortTableDivider })] }), _jsx(ColumnDescribedTable, { data: tableData, showingInfo: function (_a) {
                    var total = _a.total, count = _a.count;
                    return "Showing ".concat(count, " of ").concat(total, " leader").concat(total !== 1 ? "s" : "");
                }, columnDescriptions: getColumnDescriptions(column1Attribute, column2Attribute), replaceEmpty: "--", title: "", defaultSortKeyOrder: [
                    { column: "name", direction: ValidSortDirections.DESC },
                ] })] })));
};
export default CohortInsightsSkillsTable;
